'use strict'

module.exports =
  initialize: (@storageId) ->
    @addDealClickHandler()

  scrollToLastClickedDeal: ->
    dealId = window.sessionStorage.getItem(@storageId)
    if dealId
      deal = $(".cui-c-deal[data-bhc='" + dealId + "']")
      if deal.length
        deal.get(0).scrollIntoView()

  getLastDealId: ->
    return window.sessionStorage.getItem(@storageId)

  addDealClickHandler: ->
    storageId = @storageId
    $('#pull-cards').on('mousedown', '.cui-c-udc', (e) ->
      dealId = $(this).data("bhc")
      window.sessionStorage.setItem(storageId, dealId)
      )
